export default (data) => /* html */ `
<div class="toggle__group toggle__group--option">
  <input class="toggle__radio" name="subscription" type="radio" data-component="existingAutoReorderRadio">
  <div class="toggle__subgroup">
    <select class="toggle__select" disabled data-component="existingDropdown">
      <option disabled selected value="0">Add to Existing ${
        data[1].featureName
      }</option>
      ${data[2]
        .map(
          (currentValue) => /* html */ ` 
        <option value="${currentValue.id}">${currentValue.name}</option>
      `
        )
        .join("")}
    </select>
  </div>
</div>`;
